module.exports = __webpack_public_path__ + "static/media/vid.39eba5a0.mp4";